import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Params, QueryParamsHandling} from '@angular/router';

@Component({
  selector: 'si-go-to-route-icon',
  templateUrl: './go-to-route-icon.component.html',
  styleUrls: ['./go-to-route-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GoToRouteIconComponent {
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() href: (string | number)[];
  @Input() params: Params;
  @Input() queryParamsHandling: QueryParamsHandling = '';
  @Input() icon: string;
  @Input() iconClass: string;
  @Input() showText: boolean;
  @Input() fixedPosition: boolean;
  @Input() newTab = false;
  @Input() disabled: boolean;

  constructor() {
  }
}
